import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthKeys } from '@app/api/auth/auth.enum';
import { AuthService } from '@app/api/auth/auth.service';
import descriptografar from '@app/shared/rotinas/descriptografar';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) {}
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const hasUrlAPI = request.url.includes(environment.BASE_API_URL);

    if (hasUrlAPI) {
      let token = ''
      if (this.authService.findInStorageByKey(AuthKeys.INFO_TOKEN))
        token = descriptografar(this.authService.findInStorageByKey(AuthKeys.INFO_TOKEN) ?? '')
      else
        token = descriptografar(this.authService.findInStorageByKey(AuthKeys.LW_TOKEN) ?? '')

      // Headers internacionais (RNF-08 Jornada Offline).
      // NOTA: enviados em TODAS as requisições à API.  O backend ignora esses
      // headers nos endpoints que não tratam internacionalização, portanto não
      // há efeito colateral — mas se futuramente houver endpoints sensíveis ao
      // locale, considere restringir o envio apenas às rotas da Jornada Offline.
      const headers: Record<string, string> = {
        'x-intl-currency-code': 'BRL',
        'x-intl-currency-locale': 'pt-BR',
        'x-intl-locale': 'pt'
      };

      // Jornada Offline: JWTs de cliente (portal CarSubs) não possuem o campo
      // "organization". Enviar o código da organização via header para que o
      // backend possa usá-lo como fallback ao montar queries SQL.
      const org = sessionStorage.getItem('org');
      if (org) {
        headers['x-carsubs-org'] = org;
      }

      if (token) {
        headers['Authorization'] = token;
      }

      request = request.clone({ setHeaders: headers });
    }
    return next.handle(request);
  }
}
